import React from 'react'
import * as T from '../../../components/Table'
import { ModalObservacao } from './ModalObservacao'

export const ItemPedidosNegados = ({ pedido }) => {
  return (
    <T.Tr key={pedido.numero_pedido}>
      <T.Td>{pedido.numero_pedido}</T.Td>
      <T.Td>{pedido.nome_cliente}</T.Td>
      <T.Td>{pedido.denominacao}</T.Td>
      <T.Td>{pedido.data_negado}</T.Td>
      <T.Td>
        <ModalObservacao pedido={pedido} />
      </T.Td>
    </T.Tr>
  )
}
